import { useSelector } from 'react-redux';
import { RootState } from 'Store/index';

export default function ListOrdersAllowed() {
	const { self } = useSelector(({ App }: RootState) => App);
	return (self?.userParams.mailAdmin || self?.administrator) ?? false;
}
